var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{attrs:{"pill":"","variant":("light-" + (_vm.status ? 'primary' : 'danger'))}},[_vm._v(" "+_vm._s(_vm.status ? 'แสดงข้อมูล' : 'ไม่แสดงข้อมูล')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }